import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import styles from './messageTyping.module.scss';
/** Represents a message with an avatar and a four dot typing indicator. */
export function MessageTyping({ className, author }) {
    const rootClass = classnames({
        [styles.root]: true,
    }, className);
    return (_jsxs("div", Object.assign({ className: rootClass }, { children: [_jsx("div", Object.assign({ className: styles.avatarWrap }, { children: _jsx(Avatar, { user: author }) })), _jsxs("div", { children: [_jsx("p", Object.assign({ className: styles.name }, { children: author.name })), _jsxs("div", Object.assign({ className: styles.indicator }, { children: [_jsx("span", { className: styles.dot }), _jsx("span", { className: styles.dot }), _jsx("span", { className: styles.dot }), _jsx("span", { className: styles.dot })] }))] })] })));
}
